/**
 * Bundled SHA-256 allowlist for constants payloads.
 * A fetched manifest payload is only applied if its sha256 appears here.
 * To add a new version: run generate_constants.py, compute SHA-256, add here, ship a PWA release.
 * NEVER add hashes without verifying the payload against reference/tax-data-2026.md.
 */
export const ALLOWED_CONSTANTS_HASHES: ReadonlySet<string> = new Set([
  'c742efa5892a3e70481c8569ef8259d7954c951df589a7e77f0ae443d8445ada', // cra-2026.json v2026.1 — baseline bundled constants (2026-05-01)
]);
